import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";

export const UmbracoFormParseMagicString = (preValues: IUmbracoFormUserPreValues, key: string) => {
  if (key && key.startsWith("@")) {
    const normalizedKey = key.substring(1).toLowerCase();
    const objectKey = Object.keys(preValues).find((x) => x.toLowerCase() == normalizedKey);
    if (objectKey) {
      return preValues[objectKey];
    }
    return null;
  }
  return key;
};
